/** Normalize API user fields (handles casing / stray whitespace). */

export function normRole(user) {
  return String(user?.role ?? '').toLowerCase().trim();
}

export function normInstructorStatus(user) {
  return String(user?.instructor_status ?? '').toLowerCase().trim();
}

export function isApprovedInstructorUser(user) {
  return normRole(user) === 'instructor' && normInstructorStatus(user) === 'approved';
}

export function normAccountType(user) {
  const value = String(user?.account_type ?? 'programme_student').toLowerCase().trim();
  return value === 'short_course_learner' ? 'short_course_learner' : 'programme_student';
}

export function isShortCourseLearner(user) {
  return normRole(user) === 'student' && normAccountType(user) === 'short_course_learner';
}

export function isProgrammeStudent(user) {
  return normRole(user) === 'student' && normAccountType(user) === 'programme_student';
}

export function normShortCourseFacilitatorStatus(user) {
  return String(user?.short_course_facilitator_status ?? '').toLowerCase().trim();
}

export function isApprovedShortCourseFacilitator(user) {
  return isApprovedInstructorUser(user) && normShortCourseFacilitatorStatus(user) === 'approved';
}

export function userNeedsPhone(user) {
  if (!user) return false;
  if (user.requires_phone === true) return true;
  if (user.requires_phone === false) return false;
  return String(user.phone ?? '').trim() === '';
}
